import React, { useEffect, useState } from "react";
import mapboxgl from "mapbox-gl";
import { ActivityReservationInternalModel } from "Services/API/API";
import { getFeatureCollectionFromActivities } from "./helpers";
import { LAYER_ACTIVITIES_POINTS_NAME, SOURCE_ACTIVITIES_NAME } from "./constants";
import ClusterMarkers from "./ClusterMarkers";
import UnclusteredMarkers from "./UnclusteredMarkers";

interface ActivitiesLayerProps {
   map: mapboxgl.Map;
   activities: ActivityReservationInternalModel[];
}

const ActivitiesLayer: React.FC<ActivitiesLayerProps> = ({
   map,
   activities,
}) => {
   const [sourceLoaded, setSourceLoaded] = useState(false);

   useEffect(() => {
      const points = getFeatureCollectionFromActivities([]);
      map.addSource(SOURCE_ACTIVITIES_NAME, {
         type: "geojson",
         data: points,
         cluster: true,
         clusterRadius: 50,
      });

      map.addLayer({
         id: LAYER_ACTIVITIES_POINTS_NAME,
         type: "symbol",
         source: SOURCE_ACTIVITIES_NAME,
         filter: ["!=", "cluster", true],
      });

      setSourceLoaded(true);

      return () => {
         map.removeLayer(LAYER_ACTIVITIES_POINTS_NAME);
         map.removeSource(SOURCE_ACTIVITIES_NAME);
      };
   }, [map]);

   useEffect(() => {
      const source = map.getSource(SOURCE_ACTIVITIES_NAME);
      if (source && source.type === "geojson") {
         const points = getFeatureCollectionFromActivities(activities);
         source.setData(points);
      }
   }, [map, activities]);

   if(!sourceLoaded) return null;

   return <>
      <ClusterMarkers map={map}/>
      <UnclusteredMarkers map={map}/>
   </>;
};

export default ActivitiesLayer;
